export enum ModuleTokens {
  Name = 'ticketsList'
}
